const getters = {
  token: (state) => state.user.token,
  accesspoints: (state) => state.user.accesspoints,
};
export default getters;
